/* eslint-disable react/no-deprecated */

import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"
import contains from "ramda/src/contains"
import moment from "moment"
import _get from "lodash/get"
import _split from "lodash/split"

import EmptyState from "shared/components/EmptyState"
import EmailModal from "components/ModernEmailModal"
import ProblemSolvedModal from "./components/ProblemSolvedModal"
import Requests from "./components/Requests"
import RequestTrackingModal from "./components/RequestTrackingModal"
import RescheduleModal from "./components/RescheduleModal"
import ReOpenSolicitationModal from "./components/ReOpenSolicitationModal"
import RepairWizard from "../../components/RepairWizard"
import ModalSuccess from "../../components/ModalSuccess"
import TechnicianModal from "../../components/TechnicianModal"
import Button from "shared/components/Button/Button"
import DefaultTitle from "shared/components/DefaultTitle"
import DefaultContainer from "shared/components/DefaultContainer"
import IncidentFilterForm from "./components/IncidentFilterForm"
import WrapperSkeleton from "components/WrapperSkeleton"
import { showToast } from "components/Toast"
import AudioRequest from "./components/AudioRequest"

import styles from "./styles.css"

import { getCustomer, getBills, saveOperation } from "services/state/actions"
import {
  OSM,
  ServiceOrderDescriptionTranslations
} from "services/state/repair/constants"
import { technician } from "../../services/state/technician/reducer"
import {
  closeTechnicianModal,
  getTechnicians
} from "services/state/technician/action"
import {
  getRepair,
  getRepairByProtocol,
  downloadRequestDetails,
  sendMailRequestDetails,
  getServiceOrder,
  getInvoiceDisputingInformation,
  getProtocolDetails
} from "services/state/repair/action"
import {
  buildDownloadParams,
  buildSendMailParams
} from "./incident-manager-helpers"
import {
  DOWNLOAD_REQUEST_DETAIL_FAIL,
  SEND_MAIL_REQUEST_DETAIL_SUCCESS
} from "services/state/action-types"

import { sendGtmEventFileDownload } from "services/utils/sendGtm"

import EmptyStateIcon from "../../assets/svg/icon-ok.svg"
import IconError from "assets/svg/erro-desbloqueio.svg"
import Loading from "../../components/Loading"

class IncidentManager extends Component {
  state = {
    isOpen: false,
    isOpenEmailModal: false,
    actualOpenedProtocol: null,
    loading: false,
    modalOpen: false,
    rescheduleModal: false,
    reOpenSolicitationModal: false,
    isOpenProblemSolvedModal: false,
    isOpenSolveProblemSuccess: false,
    isOpenModalDetail: false,
    showTechnicianModal: false,
    isOpenAudioRequestModal: false,
    protocol: {}
  }

  openIndexedModal = (demand, modal) => {
    this.setState({ demand, [modal]: true, loading: false })
  }

  openModal = (demand, modal) => {
    const { customer } = this.props

    if (demand.qualifyType === "INVOICE_CONTESTATION") {
      this.getInvoiceDisputingAdditionalInformation(demand.requestId)
    }

    this.props.saveOperation(
      customer,
      demand.protocolNumber,
      "DEMAND_MONITORING",
      "DETAIL",
      "SUCCESS",
      "",
      "Histórico de Solicitações"
    )

    this.setState({ demand, [modal]: true, loading: false })
  }

  closeIndexedModal = (modal) => {
    this.setState({ [modal]: false })
  }

  closeModal = (modal) => {
    this.setState({ [modal]: false })
  }

  onCloseErrorModal = () => {
    window.location = "/"
  }

  componentWillMount() {
    const { bills, getBills } = this.props
    !bills && getBills()
  }

  componentDidMount() {
    const { getRepair } = this.props

    const startDate = moment().subtract(1, "month").format("DD/MM/YYYY")
    const endDate = moment().format("DD/MM/YYYY")

    const payload = {
      startDate,
      endDate
    }
    getRepair(payload)
  }

  canShowStages = (demand) => {
    return contains(demand.system, ["OSM", "SOM"])
  }

  getInvoiceDisputingAdditionalInformation = (requestId) => {
    this.props.getInvoiceDisputingInformation(requestId, (data) => {
      this.setState({
        demand: {
          ...this.state.demand,
          invoice: data.invoiceId + "/" + data.invoiceAux,
          invoiceDate: data.invoiceDate,
          invoiceValue: data.invoiceValue,
          selectedReason: data.selectedReason,
          disputingData: data.disputingData
        }
      })
    })
  }

  openDetailsModal = (demand) => {
    const { getServiceOrder } = this.props

    if (demand.qualifyType === "Contestação de fatura") {
      this.getInvoiceDisputingAdditionalInformation(demand.requestId)
    }

    this.setState({ demand, loading: true })

    return this.canShowStages(demand)
      ? getServiceOrder(
          demand,
          this.openIndexedModal(demand, "isOpenModalDetail")
        )
      : this.openIndexedModal(demand, "isOpenModalDetail")
  }

  showModal = () => {
    this.setState({ loading: false, openModal: true })
  }

  getDescriptionAttrBySystem({ system }) {
    const attrNameBySystem = {
      [OSM]: "worklistName"
    }

    return attrNameBySystem[system]
  }

  getDescriptionKey(demand) {
    const attrName = this.getDescriptionAttrBySystem(demand)
    return attrName && demand[attrName]
  }

  getDescription = (demand) => {
    const { t } = this.props
    const descriptionKey = this.getDescriptionKey(demand)

    return descriptionKey
      ? t(ServiceOrderDescriptionTranslations[descriptionKey])
      : demand.qualifyTypeDescription
  }

  download = (protocol) => {
    const params = buildDownloadParams(protocol)
    const { downloadRequestDetails } = this.props

    return downloadRequestDetails(params, (response) => {
      const errorRequest = response.type === DOWNLOAD_REQUEST_DETAIL_FAIL

      if (!errorRequest) {
        sendGtmEventFileDownload("Detalhamento do protocolo")
      }

      showToast({
        message: errorRequest
          ? "Cliente, ocorreu um erro em  seu download! Tente novamente dentro de alguns minutos."
          : "Cliente, o seu download foi realizado com sucesso! Você já consegue acessar o arquivo em seu dispositivo.",
        type: errorRequest ? "error" : "sucess"
      })
    })
  }

  sendForMail = (email) => {
    const { sendMailRequestDetails, customer } = this.props
    const { actualOpenedProtocol } = this.state

    const params = buildSendMailParams(
      { email },
      customer,
      actualOpenedProtocol
    )

    this.setState({
      isOpenEmailModal: false
    })

    return sendMailRequestDetails(params, (response) => {
      const sucecss =
        _get(response, "type", "") === SEND_MAIL_REQUEST_DETAIL_SUCCESS
      const message = sucecss
        ? "Cliente, o seu protocolo foi enviado para e-mail com sucesso!"
        : "Cliente, ocorreu um erro ao enviar seu protocolo por e-mail! Tente novamente dentro de alguns minutos."

      showToast({
        type: sucecss ? "sucess" : "error",
        message
      })
    })
  }

  openEmailModal = (actualOpenedProtocol) => {
    this.setState({ isOpenEmailModal: true, actualOpenedProtocol })
  }

  closeEmailModal = () => {
    this.setState({ isOpenEmailModal: false })
  }

  callGetRepair = (startDate, endDate) => {
    this.props.getRepair({ startDate, endDate })
  }

  onCreateIncident = () => {
    this.setState({ showRepairWizard: true })
  }

  onCreateIncidentClose = () => {
    this.setState({ showRepairWizard: false })
  }

  isSiebel = () => {
    return true
  }

  filterRepair = (payload) => {
    if (!payload.protocol) {
      this.props.getRepair(payload, this.getRepairSuccess, this.getRepairFail)
    }

    if (payload.protocol) {
      this.props.getRepairByProtocol(
        payload,
        this.getRepairSuccess,
        this.getRepairFail
      )
    }

    this.setState({
      loading: true
    })
  }

  getRepairSuccess = () => {
    this.setState({
      loading: false
    })
  }

  getRepairFail = () => {
    this.setState({
      loading: false
    })
  }

  onTrackTechniciansModal = (demand) => {
    this.setState({ demand }, () => {
      if (demand && demand.cartTechnicianId) {
        this.props.getTechnicians([demand.cartTechnicianId], true)
      }
    })
  }

  handleOpenAudioRequestModal = async (protocol) => {
    const protocolNumber = _split(protocol.protocolNumber, "-")[0]

    this.props.getProtocolDetails(
      { protocolId: protocolNumber },
      (response) => {
        if (response && response.payload.data.requestChannel !== "TELEFONE") {
          showToast({
            message: "Solicitação de áudio indisponível para esse protocolo",
            type: "error"
          })
          return
        }
        this.setState({
          protocol,
          isOpenAudioRequestModal: true
        })
      },
      (error) => {
        console.error(
          "Error fetching service data [getProtocolDetails] ",
          error
        )
        showToast({
          message:
            "Ocorreu um erro interno no servidor. Por favor, tente novamente!",
          type: "error"
        })
      }
    )
  }

  handleCloseAudioRequestModal = () => {
    this.setState({ protocol: {}, isOpenAudioRequestModal: false })
  }

  render() {
    const {
      loading,
      t,
      error,
      customerDemands,
      completed,
      progress,
      showTechnicianModal,
      customer,
      loadingProtocolDetails
    } = this.props
    const {
      rescheduleModal,
      reOpenSolicitationModal,
      demand,
      isOpenAudioRequestModal,
      protocol
    } = this.state

    return (
      <Fragment>
        <Loading isOpen={loadingProtocolDetails} />
        <DefaultTitle>Protocolos</DefaultTitle>
        <DefaultContainer>
          <IncidentFilterForm
            onFilter={this.filterRepair}
            onCreateIncident={this.onCreateIncident}
          />

          <WrapperSkeleton path="tableProtocol" isChildrenReady={!loading}>
            {(progress.length > 0 || completed.length > 0) && !error ? (
              <Requests
                onShowDetailsProgress={this.openDetailsModal}
                onShowDetailsCompleted={this.openModal}
                progressDemands={progress}
                completedDemands={completed}
                getDescription={this.getDescription}
                onReschedule={this.openIndexedModal}
                onTrackTechnician={this.onTrackTechniciansModal}
                onShowProblemSolvedModal={this.openModal}
                onDownload={this.download}
                onSendMail={this.openEmailModal}
                loading={loading}
                t={t}
                onAudioRequestModal={this.handleOpenAudioRequestModal}
              />
            ) : !error ? (
              <EmptyState
                icon={EmptyStateIcon}
                isContainer={false}
                classNames={styles.emptyState}
                title="Não existe nenhum protocolo em aberto!"
                description="Você não possui protocolos cadastrados ou em processo de resolução."
              >
                <Button isLink url="/AreaClienteCorporativo" fontWeight="fw-5">
                  {t("MSG_0232")}
                </Button>
              </EmptyState>
            ) : (
              <EmptyState
                isContainer={false}
                classNames={styles.emptyState}
                icon={IconError}
                title={t("MSG_0272")}
              />
            )}
          </WrapperSkeleton>
        </DefaultContainer>

        <RequestTrackingModal
          customerDemands={customerDemands}
          isOpen={this.state.isOpenModalDetail}
          demand={this.state.demand}
          onClose={() => this.closeModal("isOpenModalDetail")}
        />

        <ProblemSolvedModal
          isOpen={this.state.isOpenProblemSolvedModal}
          demand={this.state.demand}
          onAnswer={() => this.openModal("isOpenSolveProblemSuccess")}
          onClose={() => this.closeModal("isOpenProblemSolvedModal")}
        />

        <ModalSuccess
          isOpen={this.state.isOpenSolveProblemSuccess}
          onClose={() => this.closeModal("isOpenSolveProblemSuccess")}
          msg={t("MSG_0372")}
        />

        <EmailModal
          isOpen={this.state.isOpenEmailModal}
          onSubmit={this.sendForMail}
          email={customer.email || ""}
          onClose={this.closeEmailModal}
        />

        <RescheduleModal
          isOpen={rescheduleModal}
          demand={demand}
          customer={customer}
          onClose={() => this.closeIndexedModal("rescheduleModal")}
        />

        <ReOpenSolicitationModal
          isOpen={reOpenSolicitationModal}
          demand={demand}
          onCreateIncident={this.onCreateIncident}
          onClose={() => this.closeIndexedModal("reOpenSolicitationModal")}
          message="Você pode reabrir sua solicitação se o problema não foi resolvido."
        />

        <TechnicianModal
          isOpen={showTechnicianModal}
          activityIds={
            demand && demand.cartTechnicianId ? [demand.cartTechnicianId] : []
          }
          onClose={this.props.closeTechnicianModal}
        />

        {this.state.showRepairWizard && (
          <RepairWizard onClose={this.onCreateIncidentClose} />
        )}

        {isOpenAudioRequestModal && (
          <AudioRequest
            protocol={protocol}
            onCloseModal={this.handleCloseAudioRequestModal}
          />
        )}
      </Fragment>
    )
  }
}

IncidentManager.propTypes = {
  customer: PropTypes.object,
  saveOperation: PropTypes.func,
  bills: PropTypes.object,
  getBills: PropTypes.func,
  getRepair: PropTypes.func,
  getInvoiceDisputingInformation: PropTypes.func,
  getServiceOrder: PropTypes.func,
  t: PropTypes.func.isRequired,
  downloadRequestDetails: PropTypes.func,
  sendMailRequestDetails: PropTypes.func,
  getRepairByProtocol: PropTypes.func,
  getTechnicians: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  customerDemands: PropTypes.object,
  completed: PropTypes.object,
  progress: PropTypes.object,
  showTechnicianModal: PropTypes.bool,
  closeTechnicianModal: PropTypes.func,
  getProtocolDetails: PropTypes.func,
  loadingProtocolDetails: PropTypes.bool
}

const mapStateToProps = ({ repair, customer, bills }) => ({
  ...repair,
  repair,
  customer: customer.data,
  progress: repair.progress,
  completed: repair.completed,
  bills: bills.data,
  customerDemands: repair.demand ? repair.demand : [],
  loadingDetails: repair.loadingDetails,
  loading: repair.loading,
  error: repair.error,
  showTechnicianModal: technician.isModalOpen,
  loadingProtocolDetails: repair.loadingProtocolDetails
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, {
    getRepair,
    getRepairByProtocol,
    sendMailRequestDetails,
    downloadRequestDetails,
    getCustomer,
    getBills,
    getServiceOrder,
    getInvoiceDisputingInformation,
    closeTechnicianModal,
    getTechnicians,
    saveOperation,
    getProtocolDetails
  })
)

export default enhance(IncidentManager)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/index.js